export default function FileQuestion() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="file-question">
                <path
                    id="Icon"
                    d="M16.6654 7.91666V5.66666C16.6654 4.26653 16.6654 3.56646 16.3929 3.03168C16.1532 2.56128 15.7707 2.17882 15.3003 1.93914C14.7656 1.66666 14.0655 1.66666 12.6654 1.66666H7.33203C5.9319 1.66666 5.23183 1.66666 4.69706 1.93914C4.22665 2.17882 3.8442 2.56128 3.60451 3.03168C3.33203 3.56646 3.33203 4.26653 3.33203 5.66666V14.3333C3.33203 15.7335 3.33203 16.4335 3.60451 16.9683C3.8442 17.4387 4.22665 17.8212 4.69706 18.0608C5.23183 18.3333 5.9319 18.3333 7.33203 18.3333H11.6654M11.6654 9.16666H6.66536M8.33203 12.5H6.66536M13.332 5.83332H6.66536M13.7487 12.5019C13.8955 12.0845 14.1853 11.7325 14.5668 11.5083C14.9483 11.2841 15.3968 11.2022 15.8329 11.277C16.269 11.3518 16.6645 11.5785 16.9495 11.917C17.2344 12.2555 17.3904 12.6839 17.3897 13.1264C17.3897 14.3755 15.5161 15 15.5161 15M15.5403 17.5H15.5486"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
